import Analytics from '@/utils/analytics';
import React from 'react';
import { ActivityIndicator } from '@/components/activity-indicator';
import { CannedQuestion } from './canned-question';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { toPercentageString } from '@/utils/percentage';
import { useCannedQuestionsContext } from '@/contexts/canned-questions-context';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  maxSize?: number;
  numColumns?: number;
  onQuestionSelected: (question: string) => void;
}

export const CannedQuestionList: React.FC<Props> = ({
  maxSize,
  numColumns,
  onQuestionSelected,
}) => {
  const windowDimensions = useWindowDimensions();
  const { isSmallLayout } = useLayoutContext();
  const {
    loading,
    questions,
    onQuestionClick: onClickedCannedQuestion,
  } = useCannedQuestionsContext();
  const numOfQuestions = maxSize || questions.length;

  return (
    <View style={[isSmallLayout ? styles.container : styles.deskContainer]}>
      {loading ? (
        <View
          style={[
            styles.loadingPreview,
            {
              width: windowDimensions.width * (isSmallLayout ? 0.9 : 0.5),
            },
          ]}
        >
          <View style={styles.loadingContainer}>
            <ActivityIndicator testID="loading-indicator" />
          </View>
        </View>
      ) : (
        questions.slice(0, numOfQuestions).map((q) => (
          <CannedQuestion
            category={q.category}
            containerStyle={[
              {
                width: numColumns
                  ? toPercentageString(100 / numColumns)
                  : toPercentageString(100 / numOfQuestions),
              },
              styles.questionContainer,
            ]}
            contentStyle={styles.questionContent}
            key={q._id}
            onPress={() => {
              onQuestionSelected(q.question);
              onClickedCannedQuestion(q._id);
              Analytics.track('casey_ai_canned_question.press', {
                question: q.question,
              });
            }}
            question={q.question}
            title={q.title}
          />
        ))
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  deskContainer: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  loadingContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  loadingPreview: {
    minHeight: 160,
  },
  questionContainer: {
    maxWidth: 204,
    minHeight: 160,
  },
  questionContent: {
    flex: 1,
    marginRight: 4,
    marginVertical: 4,
  },
});
